// extracted by mini-css-extract-plugin
export const socialMediaBar = "social-media-module--social-media-bar--2mEX3";
export const show = "social-media-module--show--1dosJ";
export const instagramLink = "social-media-module--instagram-link--20hWr";